(function () {
  'use strict';

  if (window.UnifiedProjectConfig) {
    return;
  }

  const DAY = 24 * 60 * 60 * 1000;

  window.UnifiedProjectConfig = {
    version: '2.1.0',
    project: 'povestedevin',

    ga4: {
      measurementId: 'G-N87KLMPH3R',

      parameterRegistry: {
        page_type: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        page_subtype: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        journey_area: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        section_name: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'medium'
        },

        section_type: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        source_section: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'medium'
        },

        source_component: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'medium'
        },

        source_mechanism: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        interaction_type: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        product_sku: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'medium'
        },

        variant_id: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'medium'
        },

        product_type: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        item_class: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        commercial_product: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        first_meaningful_source: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        last_meaningful_source: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        recommendation_source: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        choice_dimension: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        choice_value: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'medium'
        },

        sommelier_style: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        sommelier_body: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        sommelier_taste: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        bundle_type: {
          send: true,
          role: 'dimension',
          register: true,
          cardinality: 'low'
        },

        section_index: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'low'
        },

        visibility_ratio: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'low'
        },

        visible_ms: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'low'
        },

        seconds_since_page_load: {
          send: true,
          role: 'metric',
          register: false,
          cardinality: 'low'
        },

        result_count: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'low'
        },

        items_selected: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'low'
        },

        /*
         * Unified Tracking 2.1
         * BI Registry Completion
         *
         * Stock Friction Intelligence
         */

        requested_quantity: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'low'
        },

        added_quantity: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'low'
        },

        blocked_quantity: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'low'
        },

        /*
         * Bundle Intelligence
         */

        progress_percent: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'low'
        },

        bundle_value: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'medium'
        },

        items_remaining: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'low'
        },

        bundle_size: {
          send: true,
          role: 'metric',
          register: true,
          cardinality: 'low'
        }
      }
    },

    clarity: {
      projectId: 'vvpsa2dsr2',

      highSignalEvents: [
        'sommelier_start',
        'sommelier_result',
        'sommelier_recommendation_click',
        'guidance_open',
        'guidance_continue',
        'bundle_start',
        'bundle_complete',
        'stock_limit_reached',
        'checkout_started',
        'purchase'
      ]
    },

    attribution: {
      storageKey: 'ut_attribution_context',
      ttlMs: 30 * DAY
    },

    bridge: {
      queueKey: 'ut_shopify_event_queue',
      ttlMs: 7 * DAY,
      maxEvents: 100
    },

    bundle: {
      rootSelector:
        '.gbbMixAndMatchBundleWrapper.gbbMixAndMatchProductPageAppBlock',

      itemSelector:
        '.gbbMixCascadeProductWrapper[data-product-id][data-current-selected-variant-id][data-product-quantity]',

      quantityAttribute:
        'data-product-quantity',

      productIdAttribute:
        'data-product-id',

      variantIdAttribute:
        'data-current-selected-variant-id',

      titleSelector:
        '.gbbMixCascadeProductTitle',

      priceSelector:
        '.gbbMixCascadeProductsPrice',

      type:
        'mix_and_match_6',

      sourceSection:
        'bundle_builder',

      size:
        6,

      progressThresholds: [
        25,
        50,
        75,
        100
      ],

      interactionSettleMs:
        80,

      intentTtlMs:
        1500
    },

    items: {
      nonCommercial: [
        {
          sku: 'SGR',

          variantIds: [
            '57090894365054'
          ],

          itemClass:
            'deposit'
        }
      ]
    }
  };

  const config =
    window.UnifiedTrackingConfig;

  if (!config) {
    console.error(
      '[Unified Project Config] unified-config.js must load before unified-project-config.js.'
    );

    return;
  }

  config.version =
    '2.1.0';

  config.providers.ga4 =
    true;

  config.providers.clarity =
    true;

  config.providers.meta =
    false;

  Object.assign(
    config.events,
    {
      cta_click: {
        category:
          'engagement',

        service:
          'commerce',

        conversion:
          false
      },

      navigation_click: {
        category:
          'engagement',

        service:
          'commerce',

        conversion:
          false
      },

      product_card_click: {
        category:
          'engagement',

        service:
          'commerce',

        conversion:
          false
      },

      accordion_open: {
        category:
          'engagement',

        service:
          'commerce',

        conversion:
          false
      },

      selector_change: {
        category:
          'engagement',

        service:
          'commerce',

        conversion:
          false
      },

      filter_change: {
        category:
          'engagement',

        service:
          'commerce',

        conversion:
          false
      },

      search_submit: {
        category:
          'engagement',

        service:
          'commerce',

        conversion:
          false
      },

      media_interaction: {
        category:
          'engagement',

        service:
          'commerce',

        conversion:
          false
      },

      external_link_click: {
        category:
          'engagement',

        service:
          'commerce',

        conversion:
          false
      },

      whatsapp_click: {
        category:
          'lead',

        service:
          'commerce',

        conversion:
          true
      },

      sommelier_start: {
        category:
          'discovery',

        service:
          'commerce',

        conversion:
          false
      },

      sommelier_choice: {
        category:
          'discovery',

        service:
          'commerce',

        conversion:
          false
      },

      sommelier_result: {
        category:
          'discovery',

        service:
          'commerce',

        conversion:
          false
      },

      sommelier_recommendation_click: {
        category:
          'discovery',

        service:
          'commerce',

        conversion:
          false
      },

      guidance_open: {
        category:
          'decision_support',

        service:
          'commerce',

        conversion:
          false
      },

      guidance_choice: {
        category:
          'decision_support',

        service:
          'commerce',

        conversion:
          false
      },

      guidance_continue: {
        category:
          'decision_support',

        service:
          'commerce',

        conversion:
          false
      },

      guidance_close: {
        category:
          'decision_support',

        service:
          'commerce',

        conversion:
          false
      },

      bundle_start: {
        category:
          'bundle',

        service:
          'commerce',

        conversion:
          false
      },

      bundle_item_add: {
        category:
          'bundle',

        service:
          'commerce',

        conversion:
          false
      },

      bundle_item_remove: {
        category:
          'bundle',

        service:
          'commerce',

        conversion:
          false
      },

      bundle_progress: {
        category:
          'bundle',

        service:
          'commerce',

        conversion:
          false
      },

      bundle_complete: {
        category:
          'bundle',

        service:
          'commerce',

        conversion:
          false
      },

      bundle_abandon: {
        category:
          'bundle',

        service:
          'commerce',

        conversion:
          false
      },

      stock_limit_reached: {
        category:
          'commerce_friction',

        service:
          'commerce',

        conversion:
          false
      }
    }
  );

  const clarityRoutedEvents =
    window.UnifiedProjectConfig
      .clarity
      .highSignalEvents
      .filter(
        function (eventName) {
          return Boolean(
            config.events[
              eventName
            ]
          );
        }
      );

  config.rules = {
    enabled:
      true,

    defaultDecision:
      'allow',

    definitions: [
      {
        id:
          'route_high_signal_to_clarity',

        description:
          'Route PDV high-signal Unified events to GA4 and Clarity.',

        enabled:
          true,

        priority:
          1000,

        events:
          clarityRoutedEvents,

        actions: [
          {
            type:
              'route',

            routes: [
              'ga4',
              'clarity'
            ]
          }
        ]
      }
    ]
  };
})();